exports.onPreRouteUpdate = ({ location }) => {
  if (!localStorage.getItem('impactscore:id')) {
    const id = `${Date.now()}${Math.floor(
      Math.random() * (999 - 100 + 1) + 100
    )}`;
    localStorage.setItem('impactscore:id', id);
  }
};
